import React, { Component } from 'react';
import PropTypes from 'prop-types';
// components
import RangeManage from './at/cursor';
import Emoji from './emoji';
import AtCom from './at';
// util
import { getByteLen, getRealLen } from '../util/tool';

class RichTextarea extends Component {
    constructor(props) {
        super(props);
        this.initLimit = props.limit;
        const value = props.value || '';
        this.state = {
            rangeData: {
                text: value,
                start: value.length,
                end: value.length
            },
            len: this.initLimit - Math.ceil(getByteLen(value) / 2)
        };
        this.saveEmoji = this.saveEmoji.bind(this);
        this.input = this.input.bind(this);
        this.keyup = this.keyup.bind(this);
        this.saveRange = this.saveRange.bind(this);
        this.getTextarea = this.getTextarea.bind(this);
        this.saveValue = this.saveValue.bind(this);
        this.changeValue = this.changeValue.bind(this);
        this.setLimit = this.setLimit.bind(this);
        this.insertPlaceholder = this.insertPlaceholder.bind(this);
    }

    // 获取textarea值
    getValue() {
        const desc = this.refs.desc;
        return desc.value;
    }

    // 获取textarea元素
    getTextarea() {
        return this.refs.desc;
    }

    input(e) {
        this.saveRange(e);
    }

    keyup(e) {
        // if(e.keyCode == 8){
        this.saveRange(e);
        // }
    }

    // 存储textarea选区内容
    saveRange(e) {
        if (e && e.type == 'click') {
            e.stopPropagation();
        }
        const ele = this.refs.desc;
        const rangeData = RangeManage.getCursor(ele);
        // console.log('===save===',e ? e.type : "null",JSON.stringify(rangeData), JSON.stringify(this.state.rangeData));
        this.setState({
            rangeData
        });
    }

    saveEmoji(data) {
        const self = this;
        const text = `[${data.key}]`;
        self.saveValue(text);
    }

    // value为追加的内容
    saveValue(value, rangeData, notlimit = false) {
        const isSetLimit = !notlimit;
        const self = this;
        const ele = self.refs.desc;
        RangeManage.addText({
            ele,
            rangeData: rangeData || self.state.rangeData,
            text: value,
            callback() {
                self.saveRange({ type: 'save' });
                isSetLimit && self.setLimit(ele.value);
            }
        });
    }

    setLimit(value) {
        const { onChange, showNegative } = this.props;
        const initLimit = this.initLimit;
        let len = getByteLen(value);
        len = initLimit - Math.ceil(len / 2);
        // 超出字数
        if (len < 0 && !showNegative) {
            const rangeData = {
                text: '',
                start: getRealLen(value, initLimit),
                end: value.length
            };
            this.saveValue('', rangeData, true);
            this.setState({
                len: 0
            });
            return;
        }
        this.setState({
            len
        });
        const msg = len < 0 ? '超出范围' : '';
        onChange && onChange(value, msg);
    }

    changeValue(e) {
        this.setLimit(e.target.value);
    }

    shouldComponentUpdate(nextProps, nextState) {
        const propChange = (
            nextProps.limit == this.props.limit
                && nextProps.value == this.props.value
        );
        const stateChange = (
            nextState.rangeData.text == this.state.rangeData.text
            && nextState.rangeData.start == this.state.rangeData.start
            && nextState.rangeData.end == this.state.rangeData.end
        );
        if (propChange && stateChange) {
            return false;
        }
        // if(nextProps.value != this.props.value){
        //     this.refs.desc.value = '';
        // }
        return true;
    }

    compact = (itm) => {
        if (!itm || itm === '') return false;
        return true;
    }

    innerFocus = () => {
        const desc = this.refs.desc;
        desc.focus();
    }

    insertPlaceholder() {
        setTimeout(() => {
            const { len } = this.state;
            if (this.placeholder && this.props.insertPlaceholder && len == this.initLimit) {
                this.placeholder.innerHTML = this.props.insertContent;
            }
        }, 0);
    }

    componentWillReceiveProps(nextProps) {
        this.insertPlaceholder();
        this.refs.desc.value = nextProps.value;
    }

    componentDidMount() {
        this.insertPlaceholder();
    }

    render() {
        const { rangeData, len } = this.state;
        const {
            userId, value, showNegative, placeholder, showInnerPlaceholder, textOnly, noemoji, disabled
        } = this.props;
        let clazz = 'count f-fr s-fc14 j-flag f-fs0';
        if (len < 0) {
            clazz = 'count f-fr j-flag s-fc6';
        }
        return (
            <div className="intro u-txt u-txt-area f-pr">
                {(len !== this.initLimit || showInnerPlaceholder) ? null : <span ref={(ref) => { this.placeholder = ref; }} className="placeholder" onClick={this.innerFocus}>{placeholder}</span>}
                <textarea disabled={disabled} value={value} onClick={this.saveRange} onInput={this.input} onKeyUp={this.keyup} ref="desc" onChange={this.changeValue} className="text" />
                {!textOnly
                    ? (
                        <div className="oper f-cb">
                            {!noemoji ? (
                                <div className="face f-fl f-pr">
                                    <Emoji onChange={this.saveEmoji} />
                                </div>
                            ) : null}
                            <span className={clazz}>{len}</span>
                        </div>
                    )
                    : null}
            </div>
        );
        // <AtCom userId={userId} rangeData={rangeData} saveValue={this.saveValue} getRichElement={this.getTextarea} />
    }
}
RichTextarea.propTypes = {
    value: PropTypes.string,
    limit: PropTypes.number,
    onChange: PropTypes.func,
    width: PropTypes.string,
    height: PropTypes.string
};
RichTextarea.defaultProps = {
    value: '',
    limit: 140
};
export default RichTextarea;



// WEBPACK FOOTER //
// ./client/component/textarea.js